import ActionColumnComponent from "../../../disaster/components/ActionColumn/ActionColumn";

export const getAllColumns = (viewModal, updateModal, deleteRecord) => {
  const actionColumn = ActionColumnComponent({
    viewModal,
    updateModal,
    deleteRecord,
  });

  return {
    "Current Income": [
      {
        title: "Income Source",
        dataIndex: "Income Source", 
        key: "incomeSources",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Monthly Amount",
        dataIndex: "Monthly Amount", 
        key: "monthlyAmount",
        render: (record) => 
          record !== undefined && record !== null
          ? `$${Number(record).toLocaleString("en-US", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
        })}`
      : "N/A",
      },
      {
        title: "Frequency",
        dataIndex: "Frequency", 
        key: "frequency",
        render: (record) => (record ? record : "N/A"),
      },
      actionColumn,
    ],
 
    "Spouse's Income": [
      {
        title: "Income Source",
        dataIndex: "Income Source", 
        key: "incomeSources",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Monthly Amount",
        dataIndex: "Monthly Amount", 
        key: "monthlyAmount",
        // render: (record) => (record ? record : "N/A"),
        render: (record) => 
          record !== undefined && record !== null
          ? `$${Number(record).toLocaleString("en-US", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
        })}`
      : "N/A",
      },
      {
        title: "Frequency",
        dataIndex: "Frequency", 
        key: "frequency",
        render: (record) => (record ? record : "N/A"),
      },
      actionColumn,
    ],
    "Business Interests Divorce": [
      {
        title: "Name Of Business",
        dataIndex: "Name Of Business",
        key: "nameOfBusiness",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Approx Value",
        dataIndex: "Approx Value", 
        key: "approxValue",
        // render: (record) => (record ? record : "N/A"),
        render: (record) => 
          record !== undefined && record !== null
          ? `$${Number(record).toLocaleString("en-US", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
        })}`
      : "N/A",
      },
      {
        title: "Interest %",
        dataIndex: "Interest %",
        key: "interest %",
        render: (record) => (record ? record : "N/A"),
      },
      actionColumn,
    ],
  };
};